'use strict';


var brandify = {
    init: function () {
        var iframe_id = 'locatoriframe';
        var eventMethod = window.addEventListener ? 'addEventListener' : 'attachEvent';
        var eventer = window[eventMethod];
        var messageEvent = eventMethod == 'attachEvent' ? 'onmessage' : 'message';

        eventer(messageEvent, function (e) {
            if (e.data.indexOf('w2gi:iframeHeightUpdated') !== -1) {
                var dimensions = e.data.split('//');

                autoResize(dimensions[1], dimensions[2]);
            }

            if (e.data.indexOf('w2gi:scrollPage') !== -1) {
                var offsets = document.getElementById(iframe_id).getBoundingClientRect();
                var values = e.data.split('//');
                var destination = values[1];
                var offset = values[2];

                window.scrollTo(0, destination + offsets.top);
            }
        }, false);

        function autoResize(newheight, newwidth){
            document.getElementById(iframe_id).style.height = parseInt(newheight) + 'px';
            document.getElementById(iframe_id).style.width = parseInt(newwidth) + '%';
        }

        autoResize(960, 100);
    }
}

export default brandify;
